<template>
    <div class="scrobbleParent">
        <slot></slot>
 
        <div class="icon animated"
                :class="{
                    'bounceIn' : showNow,
                    'bounceOut' : !showNow
                }"
                v-show="showNow"
                v-on:mouseover="hover=true"
                v-on:mouseleave="hover=false">
            <i class="fa fa-music fa-2x" aria-hidden="true"></i>
        </div>

        <div class="dataContainer animated"
                :class="{
                    'slideInDown' : hover,
                    'slideOutUp' : !hover
                }">
            <h3 class="intro">is currently listening to :: </h3>
            <div class="songInfo">
                <a :href="scrobble.url" target="_blank" rel="noopener">
                    <img :src="scrobble.image[0]['#text']">
                </a>
                <div>                
                    <div class="song">{{scrobble.name}}</div>
                    <div class="song">{{scrobble.artist['#text']}}</div>
                    <div class="song">{{scrobble.album['#text']}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        name: "Scrobbler",
        data(){
            return {
                hover : false,
                showNow : false,
                scrobble : {
                    name : "",
                    artist : {
                        '#text':''
                    },
                    album : {
                        '#text':''
                    },
                    image : [
                        {'#text':''}
                    ]
                }
            }
        },
        created(){
            this.getScrobble();
            setInterval(this.getScrobble, 30000);
        },
        methods : {
            getScrobble : function(){
                axios.get(process.env.VUE_APP_BASE_URL+"/lastFM")
                    .then(response => {
                        this.scrobble = response.data.recenttracks.track[0];
                        this.showNow = (this.scrobble['@attr']) ? true : false;
                    })
                    .catch(() => {
                        this.showNow = false;
                    });
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../assets/scss/_variables.scss';

    $iconSize : 70px;
    $iconOffset : -70px;

    .scrobbleParent{
        max-width: 100%;
        display: block;
        margin-left: auto;
        margin-right: auto;
        // position: relative;
        // z-index:1;

        @media screen and (max-width:$regularLaptopWidth){
            max-width: 100%;

            .dataContainer{
                .intro{
                    margin-left: 2.2rem;
                }
            }
        }
        
        @media screen and (max-width:$tabletWidth){
            .dataContainer{
                .songInfo{
                    padding: 16px 0;
                }
            }
        }

        @media screen and (max-width:$largeMobile){
            .icon,.dataContainer{
                display: none;
            }
        }
    }

    .icon{
        color: white;
        width: $iconSize;
        height:$iconSize;
        border-radius : 50%;
        background-color: $gumGreen;
        text-align: center;
        z-index: 40 !important;
        padding-top: 1em;
        border: 0.2rem solid black;
        position:relative;
        top: $iconOffset/2;
        left: $iconOffset/2;
    }

    .dataContainer{
        display: grid;
        grid-template-columns: 50% 50%;
        background: $gumGreen;
        border-radius: 0 0 20px 20px;
        z-index: 0;
        color: white;
        border: 0.2rem solid black;
        border-top: none;
        position: relative;
        top: $iconOffset;


        a{
            width: 20%;
            float: left;
        }

        .intro{
            font-size: 1rem;
            margin: 1.2rem;
            margin-left: 4.2rem;
        }

        .songInfo{
            padding: 8px 0;
            display: inline;
            .song{
                font-size: 0.8rem;
            }
        }
    }

    @keyframes shadow-pulse
    {
        0% {
            box-shadow: 0 0 0 0px rgba(0, 0, 0, 0.2);
        }
        100% {
            box-shadow: 0 0 0 35px rgba(0, 0, 0, 0);
        }
    }

</style>
